// src/api.js 或 src/utils/api.js
import axios from 'axios'

// 创建简单的 axios 实例
const api = axios.create({
  baseURL: '/api',  // 使用相对路径
  //baseURL: 'http://127.0.0.1:8000/api',  // 使用相对路径
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

export default api